import React, { useState } from 'react'

import AdminActionModal from './admin-action-modal/AdminActionModal'
import {
  AdminActionEnum,
  getLabelAdminActionButton,
  getTypeAdminActionButton,
} from './utils/admin-action-data'
import PingPongButton from '../../buttons-by-step/PingPongButton'

interface IAdminActionButtonProps {
  adminAction: AdminActionEnum
  onClickConfirm: () => void
  isLoading: boolean
}

const AdminActionButton = ({
  adminAction,
  onClickConfirm,
  isLoading,
}: IAdminActionButtonProps) => {
  const [isOpenModal, setIsOpenModal] = useState<boolean>(false)

  return (
    <>
      <PingPongButton
        dataTestId='admin-action-button'
        label={getLabelAdminActionButton({ adminAction })}
        type={getTypeAdminActionButton({ adminAction })}
        onClick={() => setIsOpenModal(true)}
      />
      {isOpenModal && (
        <AdminActionModal
          adminAction={adminAction}
          isOpenModal={isOpenModal}
          setIsOpenModal={setIsOpenModal}
          onClickConfirm={onClickConfirm}
          isLoading={isLoading}
        />
      )}
    </>
  )
}

export default AdminActionButton
